/**
 * /ios-universal-links — primary route for feature `ios-universal-links`.
 *
 * Mounts the existing `IosUniversalLinksPage` from
 * `@/features/ios-universal-links/`. A sibling namespaced route at
 * `/tracking/universal-links` also wraps this page; this file exposes the
 * canonical `/ios-universal-links` URL so dash-contract-check rule D1
 * (route file at `routes/<slug>.tsx`) passes for this slug.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { IosUniversalLinksPage } from "@/features/ios-universal-links/IosUniversalLinksPage";

export const iosUniversalLinksRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/ios-universal-links",
	component: IosUniversalLinksRoutePage,
});

export default iosUniversalLinksRoute;

function IosUniversalLinksRoutePage() {
	return (
		<main className="mx-auto flex w-full max-w-5xl flex-col gap-8 px-6 py-10">
			<header className="flex flex-col gap-2">
				<p className="text-xs font-semibold uppercase tracking-[0.12em] text-zinc-500">
					iOS tracking
				</p>
				<h1 className="text-green-700 font-semibold text-3xl tracking-tight">
					iOS universal links
				</h1>
			</header>
			<IosUniversalLinksPage />
		</main>
	);
}
